/* eslint no-extend-native: "off" */
// Polyfill taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
if (!String.prototype.startsWith) {
    String.prototype.startsWith = (search, pos) => this.substr(!pos || pos < 0 ? 0 : +pos,
        search.length) === search;
}